<template>
  <InventoryList :customer="''"/>
</template>

<script>
import InventoryList from '@/components/documents/InventoryList.vue'

export default {
  name: 'InventoryListView',
  components: {
    InventoryList
  }
}
</script>
